angular.module('biz-ng-career-details').factory('numberFormatterFn', function numberFormatterFn() {
  var numberFormatterFn = function numberFormatterFn() {
    this.convertToDollars = function convertToDollars(originalValue) {
      return _.isUndefined(originalValue) ? '$0' : '$' + originalValue.toLocaleString();
    };

    this.convertToThousandsOfDollars = function convertToThousandsOfDollars(originalValue) {
      return _.isUndefined(originalValue) ? '$0k' : '$' + Math.round(originalValue / 1000).toLocaleString() + 'k';
    };

    this.cleanNumber = function cleanNumber(originalValue) {
      return _.isUndefined(originalValue) ? '0' : Math.round(originalValue).toLocaleString();
    };

    function stripTrailingZeroes(number) {
      var floatingPointNumber = parseFloat(number);

      return floatingPointNumber === 0 ? String(0) : String(floatingPointNumber).replace(/\.+$/, '');
    }

    this.formatNumber = function formatNumber(number, format) {
      format = format || stripTrailingZeroes;

      return format.call(this, number);
    };
  };

  return new numberFormatterFn();
});



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-career-details/src/functions/number_formatter_fn.js